import React from 'react';
import { JRCIcon } from '../JRCIcon/JRCIcon';
import { JRCTypography } from '../JRCTypography/JRCTypography';
import styled, { useTheme } from 'styled-components';
import { useMemo } from 'react';
import { Colors, ColorsOrShades } from '../../styles/theme';

type MessageVariants = 'success' | 'error' | 'warning' | 'info';

export type JRCMessageProps = {
    variant: MessageVariants;
    message?: string | React.ReactNode;
    messages?: string[];
};

const Message = styled.div<{ backgroundColor: string; borderColor: string }>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    background-color: ${(props) => props.backgroundColor};
    border: 1px solid ${(props) => props.borderColor};
    border-radius: 12px;
    margin-bottom: 12px;
`;

const Li = styled.li<{ color: string }>`
    margin-left: ${({ theme }) => theme.space.md}px;

    &::marker {
        color: ${({ color }) => color};
    }
`;

export const JRCMessage = ({ variant, message, messages }: JRCMessageProps) => {
    const theme = useTheme();

    const variants: {
        [k in MessageVariants]: {
            icon: string;
            color: Colors;
            backgroundColor: ColorsOrShades;
        };
    } = useMemo(
        () => ({
            error: {
                icon: 'icon-times',
                color: 'orange',
                backgroundColor: 'orangeL90',
            },
            success: {
                icon: 'icon-check',
                color: 'green',
                backgroundColor: 'greenL90',
            },
            warning: {
                icon: 'icon-exclamation',
                color: 'orange',
                backgroundColor: 'orangeL90',
            },
            info: {
                icon: 'icon-info',
                color: 'primary',
                backgroundColor: 'primaryL90',
            },
        }),
        [],
    );

    return (
        <Message
            backgroundColor={theme.color[variants[variant].backgroundColor]}
            borderColor={theme.color[variants[variant].color]}>
            <JRCIcon
                name={variants[variant].icon}
                color={theme.color[variants[variant].color]}
                size={16}
                variant={'circle'}
            />
            {message && <JRCTypography color={variants[variant].color}>{message}</JRCTypography>}
            {messages && (
                <ul>
                    {messages.map((msg, i) => (
                        <Li color={theme.color[variants[variant].color]} key={i}>
                            <JRCTypography color={variants[variant].color}>{msg}</JRCTypography>
                        </Li>
                    ))}
                </ul>
            )}
        </Message>
    );
};
